import { FaArrowRight, FaGoogle, FaStar } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';

const reviewsUrl = 'https://www.google.com/maps/place/NJ+Design+%26+Print/@29.8362815,-95.7908357,10z/data=!4m8!3m7!1s0x22c382ebdb1eba17:0xe0bb1bb1c7274d96!8m2!3d29.836095!4d-95.46119!9m1!1b1!16s%2Fg%2F11wy71s2xf';

const reviews = [
    {
        name: 'REFUND ONE HOUSTON',
        date: { en: '6 months ago', es: 'Hace 6 meses' },
        text: {
            en: '10 out of 10 service, excellent work quality, efficiency and professionalism. Do not hesitate to contact this company if you want your business to look modern without hurting your budget.',
            es: 'Servicio 10 de 10, exelente calidad en el trabajo, eficiencia y profesionalismo,no dudes en contactar esta compania si quieres que tu negocio luzca moderno sin afectarte el bolsillo.'
        }
    },
    {
        name: 'Rosalia Acosta',
        date: { en: '1 year ago', es: 'Hace un año' },
        text: {
            en: 'I am very satisfied with the work, excellent quality, service and speed. Their dedication and professionalism are truly exceptional, which is why I recommend them without hesitation.',
            es: 'Estoy muy satisfecha con el trabajo, excelente calidad ,servicio y rapidez. Su dedicación y profesionalismo es verdaderamente excepcional por lo cual lo recomiendo sin dudas.'
        }
    },
    {
        name: 'Tahymi Soto',
        date: { en: '1 year ago', es: 'Hace un año' },
        text: {
            en: 'Excellent work. I love every project; you can see the quality and dedication in each one. As a customer, I am satisfied and recommend them 100%. 👌',
            es: 'Excelentes trabajos, me encanta cada uno de ellos, se percibe la calidad y el empeño en cada uno de ellos. Como clienta estoy satisfecha y lo recomiendo al 100 👌'
        }
    }
];

const copy = {
    en: {
        eyebrow: 'TRUSTED BY HOUSTON BUSINESSES',
        title: 'Real Google Reviews',
        subtitle: 'Feedback published by customers on our Google Business Profile.',
        reviews: 'Google reviews',
        original: 'Translated from Spanish',
        viewAll: 'Read all reviews on Google'
    },
    es: {
        eyebrow: 'LA CONFIANZA DE NEGOCIOS EN HOUSTON',
        title: 'Reseñas reales de Google',
        subtitle: 'Opiniones publicadas por clientes en nuestro Perfil de Negocio de Google.',
        reviews: 'opiniones en Google',
        original: 'Reseña original en español',
        viewAll: 'Ver todas las reseñas en Google'
    }
};

const GoogleReviews = () => {
    const { language } = useLanguage();
    const { isDark } = useTheme();
    const text = copy[language] || copy.en;

    return (
        <section className={`py-20 px-4 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`} aria-labelledby="google-reviews-title">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <p className="text-atlantis font-bold tracking-widest text-sm mb-3">{text.eyebrow}</p>
                    <h2 id="google-reviews-title" className={`text-4xl md:text-5xl font-bold mb-5 ${isDark ? 'text-white' : 'text-saratoga'}`}>
                        {text.title}
                    </h2>
                    <p className={`text-lg max-w-3xl mx-auto ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>{text.subtitle}</p>
                </div>

                <div className={`max-w-xl mx-auto mb-10 flex items-center justify-center gap-5 rounded-2xl border px-6 py-5 shadow-lg ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
                    <FaGoogle className="text-3xl text-atlantis shrink-0" aria-hidden="true" />
                    <div>
                        <div className="flex items-center gap-3">
                            <span className={`text-3xl font-bold ${isDark ? 'text-white' : 'text-saratoga'}`}>5.0</span>
                            <span className="flex gap-1 text-yellow-400" aria-label="5 de 5 estrellas">
                                {[1, 2, 3, 4, 5].map((star) => <FaStar key={star} aria-hidden="true" />)}
                            </span>
                        </div>
                        <p className={isDark ? 'text-gray-300' : 'text-gray-600'}>22 {text.reviews}</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-7">
                    {reviews.map((review) => (
                        <article key={review.name} className={`h-full flex flex-col rounded-2xl border p-7 shadow-lg ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
                            <div className="flex gap-1 text-yellow-400 mb-5" aria-label="5 de 5 estrellas">
                                {[1, 2, 3, 4, 5].map((star) => <FaStar key={star} aria-hidden="true" />)}
                            </div>
                            <blockquote lang={language === 'es' ? 'es' : 'en'} className={`leading-relaxed mb-6 ${isDark ? 'text-gray-200' : 'text-gray-700'}`}>
                                “{review.text[language] || review.text.en}”
                            </blockquote>
                            <div className="mt-auto">
                                <p className={`font-bold ${isDark ? 'text-white' : 'text-saratoga'}`}>{review.name}</p>
                                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{review.date[language] || review.date.en} · {text.original}</p>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="text-center mt-10">
                    <a href={reviewsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-gradient-to-r from-atlantis to-green-yellow-primary text-black font-bold hover:shadow-lg transition-shadow">
                        {text.viewAll} <FaArrowRight aria-hidden="true" />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default GoogleReviews;
